import Store from 'redux/store';

import { mileage, cloudloyalty } from '../clients';
import {
  FETCH_PACKAGES_BY_SUPPLIERID,
  FETCH_PACKAGES_BY_SUPPLIERID_FAIL,
  FETCH_PACKAGES_BY_SUPPLIERID_SUCCESS,
  REDEMPTION_FUEL_CREDIT,
  REDEMPTION_FUEL_CREDIT_FAIL,
  REDEMPTION_FUEL_CREDIT_SUCCESS,
} from 'redux/Reducers/FuelCredit/FuelCreditReducer';

export const FetchPackagesBySupplierId = async (
  User,
  finallyCallback = () => {},
  { supplierId, clientId }
) => {
  Store.dispatch({ type: FETCH_PACKAGES_BY_SUPPLIERID });

  mileage(User, supplierId)
    .get(`v1/packages/${supplierId}/${clientId}`)
    .then((response) => {
      Store.dispatch({
        type: FETCH_PACKAGES_BY_SUPPLIERID_SUCCESS,
        payload: {
          data: response.data,
          statusCode: response.status,
        },
      });
    })
    .catch((e) => {
      Store.dispatch({
        type: FETCH_PACKAGES_BY_SUPPLIERID_FAIL,
        error: e,
      });
    })
    .finally(() => {
      finallyCallback();
    });
};

export const redemptionFuelCredit = async (
  User,
  finallyCallback = () => {},
  { supplierId, order }
) => {
  Store.dispatch({ type: REDEMPTION_FUEL_CREDIT });

  mileage(User, supplierId)
    .post('v1/orders/redemption', order)
    .then((response) => {
      Store.dispatch({
        type: REDEMPTION_FUEL_CREDIT_SUCCESS,
        payload: {
          ...response.data,
        },
      });
    })
    .catch((e) => {
      Store.dispatch({
        type: REDEMPTION_FUEL_CREDIT_FAIL,
        error: e?.response?.data,
        payload: {
          data: e?.response?.data
        }
      });
    })
    .finally(() => {
      finallyCallback();
    });
};
